import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import AppliedFilter from './AppliedFilter'

function normalizeAuthors (authors, onFilterChange) {
  return authors.map(author => {
    return {
      title: author.username,
      value: author.id,
      onClick: onFilterChange
    }
  })
}

const AuthorSelector = ({ authors, selected, onFilterChange }) => {
  authors = normalizeAuthors(authors, onFilterChange)
  return <DropdownControl
    align={'adjust'}
    trigger={<ButtonControl title={selected ? <AppliedFilter type={selected.type} name={selected.name} /> : 'Filter by author'} class={'filter qa-author-filter'} icon={'arrowDropdown'} />}
    items={authors}
  />
}

export default AuthorSelector
